<template>
  <b-modal ref="resendDocumentModal" :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" hide-footer hide-header>
    <div class="modal-content-box">
      <b-form @submit.prevent="yesAction">
        <b-container fluid>
          <b-row>
            <b-col>
              <p class="title">
                Would you like to resend the document to the participant?
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <p class="para">
                The participant will need to provide their signature again.
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <button-cmp @click="cancel" aria-label="no" class="btn-modal button-cancel">No</button-cmp>
            </b-col>
            <b-col class="p-0">
              <p>
                <button-cmp aria-label="yes" type="submit" class="btn-modal button-resend">Yes, Resend Document</button-cmp>
              </p>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import ButtonCmp from "@/components/common/button";

export default {
  name: "resend-document-modal",
  components: { ButtonCmp },
  methods: {
    show() {
      this.$refs.resendDocumentModal.show();
    },
    hide() {
      this.$refs.resendDocumentModal.hide();
    },
    cancel() {
      this.$refs.resendDocumentModal.hide();
      this.$emit("resendDocument", false);
    },
    yesAction() {
      this.$emit("resendDocument", true);
      this.hide();
    }
  }
};
</script>

<style scoped lang="scss">
.modal-content-box {
  padding: 32px 16px 20px;
  border-radius: 3px;
  text-align: center;

  .title {
    font-size: 18px;
    font-weight: bold;
    color: #666669;
    max-width: 353px;
  }
  .para {
    font-size: 14px;
    color: #666669;
    font-weight: normal;
    padding: 10px 0 20px;
  }
}

.btn-modal {
  border-radius: 18px;
  font-size: 14px;
  font-weight: normal;
  width: 100%;
  text-transform: none;
  letter-spacing: normal;
}

.button-cancel {
  background-color: #e0e0e0;
  color: #4a4a4a;
}

.button-resend {
  color: #fff;
  background-color: #4c8ce4;
}
</style>
